import { AI_ASSISTANT_TAG } from '@micromart/utils/lib/feature-flags'

import type { User } from '@/types/user'

const ALLOWED_ROLES = ['operation', 'super']

/** Mirrors server ASSISTANT_OPEN_TO_OPERATION — set VITE_ASSISTANT_OPEN_TO_OPERATION=true to enable. */
export function isAssistantOpenToOperationRole(): boolean {
	return import.meta.env.VITE_ASSISTANT_OPEN_TO_OPERATION === 'true'
}

export function userHasAssistantAccess(user: User | null | undefined): boolean {
	if (!user) return false
	const roles: string[] = user.roles ?? []
	if (roles.includes('super')) return true
	if (!roles.some((r) => ALLOWED_ROLES.includes(r))) return false
	if (isAssistantOpenToOperationRole() && roles.includes('operation')) return true
	const tags: string[] = (user as any).tags ?? []
	return tags.includes(AI_ASSISTANT_TAG)
}
